<div class="jobseeker-uploaded-document-info">
  <h3>
    {{ 'label.UploadedDocuments' | translate }}
  </h3>
  <div class="divider"></div>
  <table>
    <thead>
      <tr>
        <th>{{ 'label.Document' | translate }}</th>
        <th>{{ 'label.Description' | translate }}</th>
        <th>{{ 'label.UploadDate' | translate }}</th>
      </tr>
    </thead>
  </table>
</div>
<hr-jobseeker-uploaded-document-item
  *ngFor="let item of jobseeker?.documents"
  [document]="item"
  (onUpdate)="onDelete($event)"
></hr-jobseeker-uploaded-document-item>
